<onep-pop-in-modal-title>Problème de connexion</onep-pop-in-modal-title>
<onep-pop-in-modal-content>
  Un problème technique nous empêche de vous connecter. Nous sommes désolés pour
  le désagrément occasionné. Nous vous invitons à réessayer.
</onep-pop-in-modal-content>
<onep-pop-in-modal-buttons>
  <button onepButton onepButtonType="primary" (click)="onRetryClick()">
    Réessayer
  </button>
</onep-pop-in-modal-buttons>
